// ALV Address
const ALV_ADDRESS = '0xCb3e9919C56efF1004E54175a01e39163a352129'

export { ALV_ADDRESS }
